export const SEARCH_STRING_TYPE = 'searchString'
export const PARTNER_TYPE = 'partner'
export const AVAILABILITY_TYPE = 'availability'
export const DATE_TO = 'dateTo'
export const DATE_FROM = 'dateFrom'
